// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bulma/css/bulma.css
// module id = 236
// module chunks = 1